import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { GlobalMessageService } from '@spartacus/core';
import { CustomRegistrationService } from 'src/app/custom-user-registration/custom-registration.service';
import { UserInformationComponent } from 'src/app/custom-user-registration/user-registration/user-information/user-information.component';
import { SharedService } from 'src/app/shared/services/shared.service';
import { NonBuyingPhysicianService } from '../../services';
import { Router } from '@angular/router';
import { DataLayerService } from 'src/app/shared/modules/data-layer';

@Component({
  selector: 'app-non-buying-physician-user-information',
  templateUrl: './non-buying-physician-user-information.component.html',
})
export class NonBuyingPhysicianUserInformationComponent
  extends UserInformationComponent
  implements OnInit
{
  constructor(
    protected accountRegService: CustomRegistrationService,
    protected cdr: ChangeDetectorRef,
    protected sharedService: SharedService,
    protected router: Router,
    protected globalMessage: GlobalMessageService,
    protected nonBuyingPhysicianService: NonBuyingPhysicianService,
    protected dataLayerService: DataLayerService
  ) {
    super(
      accountRegService,
      cdr,
      sharedService,
      router,
      globalMessage,
      dataLayerService
    );
  }
  ngOnInit(): void {
    super.ngOnInit();
    this.userInfoForm.addControl(
      'postalCode',
      new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{5}$'),
      ])
    );
    this.userInfoForm.addControl(
      'streetName',
      new FormControl('', [Validators.required])
    );
    this.userInfoForm.addControl(
      'city',
      new FormControl('', [Validators.required])
    );
    this.cdr.detectChanges();
  }

  createNewUser(userData) {
    this.userRegSub = this.nonBuyingPhysicianService
      .registerUser(userData)
      .subscribe({
        next: (res) => {
          this.handleUserCreation(res, userData);
        },
        error: (error) => {
          this.handleUserCreationErrors(error);
        },
      });
  }
}
